import React from 'react';

import { CopyButton } from '@app/components/ui/copy-button';

export interface CommandBoxProps {
  /** The command to display */
  command: string;
  /** Accessible label for the displayed value */
  label?: string;
  /** Accessible label for the copy action */
  copyLabel?: string;
}

/**
 * A component that displays a command with a copy button
 */
export const CommandBox: React.FC<CommandBoxProps> = ({
  command,
  label = 'Command line instruction',
  copyLabel = 'Copy command to clipboard',
}) => {
  return (
    <div className="flex items-center gap-2 mt-2 p-3 bg-muted rounded-lg border border-border">
      <code className="flex-1 text-xs font-mono break-all" aria-label={label}>
        {command}
      </code>
      <CopyButton value={command} iconSize="h-4 w-4" aria-label={copyLabel} />
    </div>
  );
};

export default CommandBox;
